import SysStoreList from "../component/SysStoreList";
import React from "react";

const SysStoreListContainer = () => (<SysStoreList />)

export default SysStoreListContainer;